import { CellContext } from '@tanstack/react-table'
import { WithdrawTransactionResponse } from '../../../../types'
import BankInfoCell from '../../../BankInfoCell'

type WithdrawData = WithdrawTransactionResponse['data'][number]

type ReceivingBankInfoCellProps = {
	row: CellContext<WithdrawData, unknown>['row']
}

export default function ReceivingBankInfoCell({
	row,
}: ReceivingBankInfoCellProps) {
	return (
		<BankInfoCell
			bank={row.original.bank}
			displayText={row.original.bankInfo || '-'}
		/>
	)
}
